<script lang="ts">
  import type { FPost, WithCreatorData } from 'garden-common';
  import Tag from '$lib/components/common/tagging/Tag.svelte';

  export let post: Partial<FPost<string>> & Partial<WithCreatorData>;

  let categories: string[] = [];

  function getCategories() {
    if (!post?.subcategories) return [];
    if (post?.subcategories?.length > 2) {
      return [
        post.category,
        ...post?.subcategories,
        '+' + (post?.subcategories.length - 2).toString()
      ];
    }

    return [post.category, ...(post?.subcategories ?? [])];
  }

  $: {
    post;
    categories = getCategories();
  }
</script>

<div class="flex overflow-x-scroll gap-x-2 scrollbar-hide">
  {#if post?.wasItem}
    <Tag label={'Classic'} rounded selectable={false} sm />
  {/if}
  {#each categories as category}
    {#if category}
      <Tag label={category} rounded selectable={false} sm />
    {/if}
  {/each}
</div>
